export default __webpack_public_path__ + "static/media/uikit.2524c6b8.svg";